module.exports = __webpack_public_path__ + "img/1(13).57acde06.png";